import { Weight } from "@redotech/redo-model/outbound-labels/util";
import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { Flex } from "@redotech/redo-web/flex";
import { forwardRef, memo } from "react";

export const MetricWeightInput = memo(
  forwardRef<
    HTMLDivElement,
    {
      weight: Weight | null;
      disabled: boolean;
      kg: number | undefined;
      g: number | undefined;
      updateKg: (value: number) => void;
      updateG: (value: number) => void;
      handleKgBlur: (value: string) => void;
      handleGBlur: (value: string) => void;
      interactWithScale: {
        setWeightInputRef: (ref: HTMLInputElement | null) => void;
      };
    }
  >(function MetricWeightInput(
    {
      weight,
      disabled,
      kg,
      g,
      updateKg,
      updateG,
      handleKgBlur,
      handleGBlur,
      interactWithScale,
    },
    ref,
  ) {
    return (
      <Flex dir="row" flex="1" gap="md" ref={ref}>
        <Flex flex={1}>
          <RedoIncrementDecrement
            disabled={disabled}
            fullWidth
            min={0}
            onBlur={handleKgBlur}
            placeholder={!weight ? "{mixed}" : "0"}
            ref={interactWithScale.setWeightInputRef}
            selectOnFocus
            setValue={updateKg}
            size="small"
            step="any"
            suffix="kg"
            value={kg}
          />
        </Flex>
        <Flex flex={1}>
          <RedoIncrementDecrement
            disabled={disabled}
            fullWidth
            min={0}
            onBlur={handleGBlur}
            placeholder={!weight ? "{mixed}" : "0"}
            selectOnFocus
            setValue={updateG}
            size="small"
            step="any"
            suffix="g"
            value={g}
          />
        </Flex>
      </Flex>
    );
  }),
);

export const ImperialWeightInput = memo(
  forwardRef<
    HTMLDivElement,
    {
      weight: Weight | null;
      disabled: boolean;
      lb: number | undefined;
      oz: number | undefined;
      updateLb: (value: number) => void;
      updateOz: (value: number) => void;
      handleLbBlur: (value: string) => void;
      handleOzBlur: (value: string) => void;
      interactWithScale: {
        setWeightInputRef: (ref: HTMLInputElement | null) => void;
      };
    }
  >(function ImperialWeightInput(
    {
      weight,
      disabled,
      lb,
      oz,
      updateLb,
      updateOz,
      handleLbBlur,
      handleOzBlur,
      interactWithScale,
    },
    ref,
  ) {
    return (
      <Flex dir="row" flex="1" gap="md" ref={ref}>
        <Flex flex={1}>
          <RedoIncrementDecrement
            disabled={disabled}
            fullWidth
            min={0}
            onBlur={handleLbBlur}
            placeholder={!weight ? "{mixed}" : "0"}
            ref={interactWithScale.setWeightInputRef}
            selectOnFocus
            setValue={updateLb}
            size="small"
            step="any"
            suffix="lbs"
            value={lb}
          />
        </Flex>
        <Flex flex={1}>
          <RedoIncrementDecrement
            disabled={disabled}
            fullWidth
            min={0}
            onBlur={handleOzBlur}
            placeholder={!weight ? "{mixed}" : "0"}
            selectOnFocus
            setValue={updateOz}
            size="small"
            step="any"
            suffix="oz"
            value={oz}
          />
        </Flex>
      </Flex>
    );
  }),
);
